/**
 * Collapses every run of whitespace into a single space (ie: pasted multi-line text
 * shown on one line)
 *
 * @param {string} str the string to normalize
 *
 * @returns {string} the single-spaced string
 */
export default function normalizeWhitespace(str) {
  if (!str) {
    return;
  }

  return str.replace(/\s+/g, " ").trim();
}
